import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from "react-i18next";

interface Props {
  onEditDetails: () => void;
}

const EmailUnlinkedWarning: React.FC<Props> = ({ onEditDetails }) => {
    const { t } = useTranslation('common');
    return <Alert status="error" flexDirection="column" mb="4">
    <Box display="flex" mb={2}>
      <AlertIcon />
      <Box flex="1">
        <AlertTitle>{t('common:theOriginalEmailAddressHasBeenUn')}</AlertTitle>
        <AlertDescription>{t('common:toAddANewEmailAddressPleaseEditT')}</AlertDescription>
      </Box>
    </Box>

    <Button size="md" variant="solid" onClick={onEditDetails} ml={8}>
      {t('common:editDetails')}
                </Button>
  </Alert>;
  };

export default EmailUnlinkedWarning;
